<template>
    <div v-if="shouldDisplay">
        <promotion v-if="togglePromotion" v-bind:promotion="ticketType.promotion"></promotion>
        <div>
            <p v-if="selectedEvent.ticket_sort_by === 'start_time' && ticketType.show_start_time" class="tw-text--md">
                <strong>{{ ticketType.start_time }}</strong>
            </p>
          <div class="tw-item tw-item--split tw-responsive__xs--half-padding tw-responsive__xxs--half-padding"
               v-bind:class="{ 'tw-item--pale':
                   (cartManager.getAvailableForTicketType(ticketTypeId) === 0 && !ticketType.is_sold_out) ||
                   ticketType.is_sold_out ||
                   (ticketType.bundle_ticket_type && ticketType.bundle_ticket_parent_sold_out)
          }">
                <div class="tw-grid__row tw-responsive__xs--gutter tw-responsive__xxs--gutter">
                    <div class="tw-grid__col--50">
                        <h4 class="tw-text--flush">{{ticketType.name}}</h4>
                        <p class="tw-text--sm tw-text--flush">
                            <span class="tw-info">
                                <font-awesome-icon :icon="['far', 'clock']" />
                                {{ selectedEvent.getTicketTypeStartTime(ticketTypeId) }}
                            </span>
                            <span class="tw-info">
                                - {{ selectedEvent.getTicketTypeEndTime(ticketTypeId) }}
                            </span>
                        </p>
                        <ul class="tw-list--styleless tw-responsive__xs--visible tw-responsive__xxs--visible">
                            <li v-if="ticketType.remaining" class="tw-widget--clearfix tw-responsive__xs--visible tw-responsive__xxs--visible">
                                <urgency-label v-bind:remaining="ticketType.total_ticket_quota - ticketType.total_ticket_attendees_and_reservations" :key="ticketType.remaining"></urgency-label>
                            </li>

                            <li v-for="(labelText, index) in ticketLabels" :key="index">
                                <span class="tw-label">{{labelText}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="tw-grid__col--50 tw-text--right">
                        <p class="tw-tickets__price tw-text--inline tw-responsive__xs--collapse tw-responsive__xxs--collapse tw-text--lg">
                            <span v-if="getTicketTypePriceText(ticketTypeId) > 0">{{ getTicketTypePriceText(ticketTypeId) | currency }}</span>
                            <span v-if="!getTicketTypePriceText(ticketTypeId)">{{ 'Free' }}</span>
                            <small class="tw-responsive__xs--hide" v-if="ticketType.price_excluding_vat">
                                (<span>{{ ticketType.price_excluding_vat | currency }}</span>
                                <span v-if="selectedEvent.currency != 'AUD'"> exc VAT </span>
                                <span v-else> exc GST </span>
                                )
                            </small>
                            <small class="tw-responsive__sm--hide tw-responsive__md--hide tw-responsive__lg--hide" v-if="ticketType.price_excluding_vat">
                                <br>(<span>{{ ticketType.price_excluding_vat | currency }}</span>
                                <span v-if="selectedEvent.currency != 'AUD'"> exc VAT </span>
                                <span v-else> exc GST </span>
                                )
                            </small>
                            <span class="tw-tickets__soldout tw-label tw-text--sm">Sold Out</span>
                        </p>
                        <div class="tw-parent-quantity-select">
                            <quantity-select v-bind:available='ticketType.remaining' v-bind:ticketId="ticketType.id" v-bind:cartManager="cartManager" v-bind:disableButton="cartManager.getAvailableForTicketType(ticketTypeId) === 0"></quantity-select>
                        </div>
                    </div>
                </div>

                <div v-if="ticketType.promotion" class="tw-grid__row tw-responsive__xs--gutter tw-responsive__xxs--gutter">
                    <div class="tw-grid__col--50">
                        <p class="tw-text tw-margin-gutter-top" v-on:click="openPromotion()">
                            <span class="tw-label tw-label--secondary tw-label--promotion">{{ticketType.promotion.name}} <font-awesome-icon :icon="['fas', 'bolt']" /></span>
                        </p>
                    </div>

                    <div v-if="promotionReduction > 0" class="tw-grid__col--50 tw-text--right">
                        <h4 class="tw-text--flush tw-margin--top-none">You save: {{promotionReduction | currency}}</h4>
                    </div>
                </div>

                <div class="tw-grid__row">
                    <div class="tw-grid__col--50 tw-grid__colxs--100">
                        <p v-if="!hideTicketDesc && ticketType.desc" class="tw-tickets__desc">
                            <span v-html="ticketDescription"></span>
                            <span v-if="ticketType.desc.showExtender" class="tw-btn__link" v-on:click="updateTicketDescription()">
                                {{  ticketDescription === ticketType.desc.shortText ? 'more' : 'less' }}
                            </span>
                        </p>
                        &nbsp;
                    </div>
                    <div class="tw-grid__col--50 tw-grid__colxs--100 tw-text--right tw-responsive__xs tw-responsive__xxs">
                        <ul class="tw-list--styleless tw-list--inline tw-text">
                            <li v-for="(labelText, index) in ticketLabels" :key="index"><span class="tw-label">{{labelText}}</span></li>
                            <li v-if="ticketType.remaining">
                                <urgency-label v-bind:remaining="ticketType.total_ticket_quota - ticketType.total_ticket_attendees_and_reservations" v-bind:total="ticketType.total_ticket_quota" :key="ticketType.remaining"></urgency-label>
                            </li>
                        </ul>

                        <ul class="tw-list--styleless tw-list--inline tw-text tw-margin-gutter-top">
                            <li v-for="(label, index) in ticketType.custom_ticket_labels" :key="index">
                                <span class="tw-label tw-label--secondary tw-custom-label" v-bind:style="{ 'color': label.font_color, 'background-color': label.background_color}">{{label.text}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="tw-grid__row">
                    <div class="tw-grid__col--100">
                        <div v-if="!selectedEvent.hide_sell_until && ticketType.sell_until" class="tw-text--right tw-responsive__xs tw-responsive__xxs tw-text--sell-until">
                            <strong> On Sale until: {{ sellUntil(ticketType.sell_until, selectedEvent) }} </strong>
                        </div>
                    </div>
                </div>
                <div class="tw-grid__row" v-if="cartManager.getAvailableForTicketType(ticketTypeId, true) === 0 && !ticketType.is_sold_out">
                    <div class="tw-grid__col--100">
                        <span class="tw-label tw-label--bold">These tickets are currently not available. They may become available if other customers release them from their basket.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang='ts'>
    import { Vue } from "vue-property-decorator";
    import { Component, Prop } from "vue-property-decorator";
    import moment from 'moment-timezone';

    // Components
    import QuantitySelect from '../quantity-select/QuantitySelect.vue';
    import TicketWidgetComponent from '../../TicketWidgetComponent';
    import UrgencyLabel from '../urgency-label/UrgencyLabel.vue';
    import Promotion from '../promotion/Promotion.vue';

    //fontawesome
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import { faClock } from '@fortawesome/free-regular-svg-icons';
    import { faBolt } from '@fortawesome/free-solid-svg-icons';

    library.add(faClock, faBolt);

    // Models
    import CartManager from '../../../services/CartManager';
    import Event from '../../../models/Event';
    import Occurrence from '../../../models/Occurrence';
    import TicketType from '../../../models/TicketType';

    declare var TICKETS_CHECKOUT: string;
    @Component({
        components: {
            QuantitySelect,
            UrgencyLabel,
            FontAwesomeIcon,
            Promotion
        }
    })

    export default class Ticket extends TicketWidgetComponent {
        @Prop() public ticketType!: TicketType;
        @Prop() public ticketTypeId!: string;
        @Prop() public promotionReduction!: number;

        shouldDisplay: boolean = true;
        ticketDescription: string = '';
        displayQuantity: boolean = false;
        ticketLabels: string[] = [];
        togglePromotion: boolean = false;

        mounted() {
            this.setUp();
        }

        setUp() {
            // if filter timeslots function get called
            this.$root.$on('displayTicket', (shouldDisplay: boolean, ticketId: string, timeSlot: string) => {
                if(timeSlot === 'All') {
                    this.shouldDisplay = true;
                } else if(this.ticketTypeId === ticketId) {
                    this.shouldDisplay = shouldDisplay;
                } else if (this.selectedEvent.hide_sold_out_tickets && (this.ticketType.is_sold_out || !this.ticketType.remaining)) {
                    this.shouldDisplay = false;
                } else if (this.selectedEvent.hide_sold_out_tickets && this.ticketType.bundle_ticket_parent_sold_out) {
                    this.shouldDisplay = false;
                }
            });

            //If this is a bundled ticket determine if the parent is sold out
            if (this.selectedEvent.hide_sold_out_tickets && this.ticketType.bundle_ticket_parent_sold_out) {
                this.shouldDisplay = false;
            }

            this.ticketLabels = this.ticketType.getTicketTypeLabels();
            this.ticketDescription = this.ticketType.desc.shortText ? this.ticketType.desc.shortText : this.ticketType.desc.fullText;

            this.trackViewItem();
        }

        /**
         * @desc toggles the ticketTypes more/less description
         */
        updateTicketDescription() {
            this.ticketDescription = this.ticketDescription === this.ticketType.desc.shortText ? this.ticketType.desc.fullText : this.ticketType.desc.shortText;
        }

        /**
         * @desc get the tickets price text
         * @return {string}
         * @param ticketId
         */
        getTicketTypePriceText(ticketId: string) : string {
            let ticketType = this.selectedEvent.getTicketType(ticketId);

            return ticketType.price;
        };

        /**
         * @desc get the sell until time of the tickets, convert TZ if needed
         * @return {string}
         * @param endDate
         * @param selectedEvent
         */
        sellUntil(endDate: string, selectedEvent: Event) : string {
            let endTime = endDate.slice(11,16);
            let timeParts = endTime.split(':');

            // set up moment time to convert from UK time
            let datetime = moment.tz(undefined, 'Europe/London');
            datetime.second(0).minute(Number(timeParts[1])).hour(Number(timeParts[0]));

            // convert to timezone time
            datetime.tz(selectedEvent.timezone);

            // get converted time to use later
            let convertedTime = datetime.format('HH:mm');

            // if event sell until isn't applied to tickets
            if(!this.selectedEvent.apply_sell_until_to_tickets) {
                let ticketSellUntil = moment(endDate);
                let occurrenceSellUntil = moment(this.selectedOccurrence.sell_until);

                if(!ticketSellUntil.isSameOrBefore(occurrenceSellUntil)) {
                    endDate = this.selectedOccurrence.sell_until;
                }
            }

            // get the sell until date time from event
            let sellUntil = moment.tz(endDate, 'Europe/London');

            // convert to timezone sell until time
            sellUntil.tz(selectedEvent.timezone);

            // use converted time parts to correct the time
            let convertedTimeParts = convertedTime.split(':');
            sellUntil.second(0).minute(Number(convertedTimeParts[1])).hour(Number(convertedTimeParts[0]));

            if(moment.tz.guess() === selectedEvent.timezone) {
                return sellUntil.format("h:mma dddd Do MMMM YYYY");
            }
            else {
                return sellUntil.format("h:mma dddd Do MMMM YYYY zz");
            }
        };

        /**
         * @desc open the promotion modal
         * @return {void}
         */
        openPromotion():void {
            this.$root.$on('closePromotion', () => {
                this.togglePromotion = false;
            });

            this.togglePromotion = !this.togglePromotion;

            return;
        }

        trackViewItem() {
            if (this.shouldDisplay && this.selectedEvent && window.dataLayer) {
                const occurrenceMoment = this.selectedOccurrence.occurrenceMoment;
                const eventDate = occurrenceMoment.format('YYYY-MM-DD');
                const dmnReferenceId = this.cartManager.purchaseId || null;

                window.dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
                window.dataLayer.push({
                    event: "view_item",
                    event_date: eventDate,
                    dmn_reference_id: dmnReferenceId,
                    ecommerce: {
                        currency: this.selectedEvent.currency,
                        value: this.ticketType.price || 0,
                        items: [{
                            item_category: "Access Tonic",
                            item_brand: this.selectedEvent.title,
                            item_name: this.ticketType.name,
                            item_id: `${this.selectedEvent._id}_${this.ticketType.id}`,
                            price: this.ticketType.price || 0,
                            item_list_id: `${this.selectedEvent._id}_${occurrenceMoment.format('YYYYMMDD')}`,
                            item_list_name: `${this.selectedEvent.title} (${eventDate})`
                        }]
                    }
                });
            }
        }
    }
</script>
